// extracted by mini-css-extract-plugin
export default {"container":"DocumentUpload_container__eqgOA","trashIcon":"DocumentUpload_trashIcon__uVvNs","preview":"DocumentUpload_preview__B5KpJ"};